import React from 'react'
import { Team } from 'src/components/team/Team'

export const TeamPage = () => {
  return (
    <div data-testid="dashboard-team-page">
      <Team />
    </div>
  )
}
